<template>
  <div class="flex m-2 md:max-w-xl md:ml-auto message" v-if="shouldShow">
    <div class="flex-grow pr-2">
      <div class="rounded-2xl flex items-center p-2 pl-3 pr-3 text-left relative inline-block float-right bg-indigo-100">
        <p class=" whitespace-pre-line break-words max-w-screen-sm relative">
          <span class="mr-2 clear-both">{{agent.attributes.name}} is typing</span>
        </p>
        <p class="typing">
          <span class="typing__dot"></span>
          <span class="typing__dot"></span>
          <span class="typing__dot"></span>
        </p>
      </div>
    </div>
    <div class="flex-initial">
      <div class="relative h-14">
        <AgentAvatar v-bind:agent="agent" diameter="34" />
      </div>
    </div>
  </div>
</template>

<script>
import { useAgentStore } from '@/stores/agents'
import AgentAvatar from '../../agents/AgentAvatar.vue'
import dayjs from "dayjs";

function scrollBottom() {
  let container = document.getElementById('message-items');
  let total = container.scrollTop + container.offsetHeight;
  let delta = container.scrollHeight - total;
  if (delta < 100 && delta > 0) {
    container.scrollTo(0, container.scrollHeight);
  }
}

export default {
  name: 'TypingAgent',
  props: ['typing'],
  components: {
    AgentAvatar,
  },
  setup() {
    let agentStore = useAgentStore();
    return { agentStore };
  },
  created() {
    this.shouldShowCalculate();
  },
  computed: {
    agent() {
      return this.agentStore.getById(this.typing.agentId);
    },
    eventTime() {
      return this.typing.time;
    }
  },
  watch: {
    eventTime(newTime) {
      if (newTime) {
        this.shouldShowCalculate();
      }
    }
  },
  methods: {
    shouldShowCalculate: function() {
      let self = this;
      this.shouldShow = dayjs().diff(this.eventTime, 'second') < 10;
      if (this.shouldShow) {
        setTimeout(function () {
          scrollBottom();
        }, 200);
        setTimeout(function () {
          self.shouldShowCalculate();
        }, 2000);
     }
    }
  },
  data() {
    return {
      shouldShow: true,
    }
  },
}
</script>
